import moment from "moment";
import { v4 as uuid } from "uuid";

import * as actionTypes from "../constants";
import { SERVER_ERROR_TYPES } from "../constants/errors";
import { NetActivityStatus } from "../models/netActivity";
import { store } from "../reduxStore";

import type { ServerErrorType } from "../constants/errors";
import type { NetActivity } from "../models/netActivity";

export const startNetActivityAction = (dispatch, url, singletonKey?: string) => {
  if (!dispatch) {
    return "";
  }

  const id = uuid();
  const currentTime = moment().format("YYYY-MM-DD HH:mm:ss");

  const netActivity: NetActivity = {
    id,
    url,
    startTime: currentTime,
    status: NetActivityStatus.NET_ACTIVITY_ACTIVE,
    singletonKey,
  };

  dispatch(netActivityStarted(netActivity));

  return id;
};

const netActivityStarted = (netActivity) => ({
  payload: netActivity,
  type: actionTypes.NET_ACTIVITY_STARTED,
});

export const stopNetActivityWithErrorAction = (
  dispatch?: Function,
  id?: string,
  errorReason?: string,
  responseStatus?: string,
  errorType?: ServerErrorType,
) => {
  if (!dispatch || !id) {
    return;
  }

  if (errorType === SERVER_ERROR_TYPES.ipForbiddenException) {
    dispatch({
      type: actionTypes.SHOW_IP_FORBIDDEN_ERROR,
    });
  }

  const currentTime = moment().format("YYYY-MM-DD HH:mm:ss");

  const netActivity: NetActivity = {
    id,
    errorReason,
    responseStatus,
    endTime: currentTime,
    status: NetActivityStatus.NET_ACTIVITY_ERROR,
  };

  dispatch(netActivityUpdated(netActivity));
};

const netActivityUpdated = (netActivity) => ({
  payload: netActivity,
  type: actionTypes.NET_ACTIVITY_UPDATED,
});

export const stopNetActivityAction = (dispatch, id, responseStatus?: string | number) => {
  if (!dispatch || !id) {
    return;
  }

  const currentTime = moment().format("YYYY-MM-DD HH:mm:ss");

  const netActivity: NetActivity = {
    id,
    endTime: currentTime,
    status: NetActivityStatus.NET_ACTIVITY_COMPLETED,
    responseStatus: responseStatus ? `${responseStatus}` : "",
  };

  dispatch(netActivityUpdated(netActivity));
};

export const restartNetActivityAction = (dispatch, id, singletonKey) => {
  if (!dispatch || !id || !singletonKey) {
    return;
  }

  const netActivity: NetActivity = {
    id,
    singletonKey,
  };

  dispatch(netActivityRestarted(netActivity));
};

const netActivityRestarted = (netActivity) => ({
  payload: netActivity,
  type: actionTypes.NET_ACTIVITY_RESTARTED,
});

export const addTokenToStorageAction = (dispatch, tokenInfo) => {
  if (!dispatch || !tokenInfo) {
    return;
  }

  dispatch(tokenUpdated(tokenInfo));
};

const tokenUpdated = (tokenInfo) => ({
  payload: tokenInfo,
  type: actionTypes.B2C_UPDATE_TOKEN_INFO,
});

// allow functions to be available in the trucode.all.js

window.startNetActivity = (url) => startNetActivityAction(store?.dispatch, url);

window.stopNetActivityWithError = (id, errorReason, responseStatus) => {
  stopNetActivityWithErrorAction(store?.dispatch, id, errorReason, responseStatus);
};

window.stopNetActivity = (id, responseStatus?: string | number) => {
  stopNetActivityAction(store?.dispatch, id, responseStatus);
};
